module.exports = __webpack_public_path__ + "app/assets/images/woman19-80028d0541467220a88d0b5d21103531.jpg";